<script setup lang="ts">
import { useOIDCStore } from '@/stores/oidc.store'
import { ref, watch } from 'vue'
import { useRouter } from 'vue-router'

const oidcStore = useOIDCStore()

const router = useRouter()

/** Flag: is the user is currently logging in or not? */
const loggingIn = ref<boolean>(false)

/**
 * Handle login button click.
 * Disables button after first click as we're redirecting externally.
 */
const handleLogin = () => {
  loggingIn.value = true
  oidcStore.signIn()
}

watch(
  () => oidcStore.user,
  (user: unknown) => {
    if (user) router.push('/')
  }
)
</script>

<template>
  <main class="login">
    <rl-login-card>
      <span v-if="oidcStore.isExpirationLoggingOut" class="text-text-tertiary text-xs"
        >Your session expired, please await while we sync with Identity Provider...</span
      >
      <el-progress
        v-if="oidcStore.isExpirationLoggingOut"
        :indeterminate="true"
        :duration="2"
        :percentage="100"
        :show-text="false"
      />
      <el-button
        type="primary"
        class="login-button"
        :disabled="
          loggingIn ||
          oidcStore.isExpirationLoggingOut ||
          !oidcStore.isInitialized ||
          (!!oidcStore.user && !oidcStore.profile)
        "
        @click.once="handleLogin"
      >
        {{ loggingIn ? 'Redirecting to Zitadel...' : 'Sign in with Zitadel' }}
      </el-button>
      <small class="self-end">
        Lost? <a class="text-text-brand" href="https://www.revolvelabs.ai">https://revolvelabs.ai</a>
      </small>
    </rl-login-card>
  </main>
</template>
